import React, { useState, useEffect } from "react";
import TableComponent from "../../TableComponent/TableComponent";
import IconButton from "../../IconButton/IconButton";
import "./SlotManagement.css";
import { DataTableComponent } from "../../../common/TableComponent/DataTableComponent";
import { useTranslation } from "react-i18next";

// const columns = [
//     { name: "Template Name", field: "assessmentName", selector: row => row.assessmentName },
//     { name: "Language Name", field: "langName", selector: row => row.langName },
//     { name: "Short Code", field: "shortCode", selector: row => row.shortCode },
//     { name: "Running Version", field: "runningVersion", selector: row => row.runningVersion },
//     { name: "Status", field: "status", selector: row => row.status },
// ];

const ViewSlot = ({ onCloseViewSlot, viewSlotData, slotDetails }) => {
    const { t } = useTranslation();
    const [tableData, setTableData] = useState([]);

    const columns = [
        { name: t("templateName"), field: "assessmentName", selector: row => row.assessmentName },
        { name: t("languageName"), field: "langName", selector: row => row.langName },
        // { name: t("shortCode"), field: "shortCode", selector: row => row.shortCode },
        { name: t("runningVersion"), field: "runningVersion", selector: row => row.runningVersion },
        { name: t("status"), field: "status", selector: row => row.status },
    ];

    useEffect(() => {
        const updatedData = viewSlotData?.map(item => ({
            ...item,
            status: item.isActive === true ? "Active" : "De-Active",
        }));
        if (updatedData !== undefined) setTableData(updatedData);
    }, [viewSlotData]);

    return (
        <div className={["slotMgmt"].join(' ')}>
            <div className="slotDetailsOuterDiv">
                <div>
                    <span className="slotDetailsText">{t("slotDetails")}:</span>
                    <span className="slotName">{slotDetails?.name}</span>
                </div>
                <div className="buttonOuterDiv">
                    <IconButton
                        text={t("close")}
                        onClick={onCloseViewSlot}
                        style={{ backgroundColor: "#F0F0F0", color: '#454647', border: '1px solid #B3B2B4' }}
                    />
                </div>
            </div>

            <div className="viewTableOuterDiv">
                <DataTableComponent
                    columns={columns}
                    data={tableData}
                    tableName="viewSlot"
                    noDataMessage={t('noPublishedAssessments')}
                    pageCount={5}
                />
            </div>
        </div>
    );
}

export default ViewSlot;
